// extracted by mini-css-extract-plugin
module.exports = {"card":"StatsTotalItem_card__16iF0","container":"StatsTotalItem_container__1oOLp","total":"StatsTotalItem_total__zlC3W","label":"StatsTotalItem_label__3XyWC"};